import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useLocation } from 'react-router-dom';
import RouterSideNavItem from 'ui-addon-react-router-dom/RouterSideNavItem';
import { useIsUngatedForM1HubPages } from '../hooks/gating/useIsUngated';
import { useIsSeatsUser } from '../hooks/user/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterSideNav = ({
  Title,
  routePath
}) => {
  const location = useLocation();
  const isUngatedForM1HubPages = useIsUngatedForM1HubPages();
  routePath = isUngatedForM1HubPages ? routePath : `/internal-development${routePath}`;
  // Check if this is the current route
  const isActive = location.pathname === routePath;

  // Create the to object with preserved query parameters
  const createToWithQueryParams = () => {
    const currentQueryParams = getQueryParams();

    // Create new URL with preserved query parameters
    const searchParams = new URLSearchParams();
    Object.entries(currentQueryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach(v => searchParams.append(key, v));
        } else {
          searchParams.set(key, value);
        }
      }
    });
    const search = searchParams.toString();
    return {
      pathname: routePath,
      search: search ? `?${search}` : ''
    };
  };
  return /*#__PURE__*/_jsx(RouterSideNavItem, {
    title: /*#__PURE__*/_jsx(Text, {
      textWrap: "nowrap",
      children: Title
    }),
    to: createToWithQueryParams(),
    padding: "400",
    marginInlineStart: "300",
    "data-selenium-class": "side-nav",
    "data-test-id": `side-nav-${routePath}`,
    "data-is-active": isActive,
    active: isActive
  });
};
export const CustomerPlatformSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.customerPlatform.tabTitle"
    }),
    routePath: "/suite"
  });
};
export const FreeToolsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/crm",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.crm.tabTitle"
    })
  });
};
export const BundleSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/bundle",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.bundle.tabTitle"
    })
  });
};
export const MarketingPlusSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/marketing-plus",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.marketingPlus.tabTitle"
    })
  });
};
export const MarketingSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/marketing",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.marketing.tabTitle"
    })
  });
};
export const SalesSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/sales",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.sales.tabTitle"
    })
  });
};
export const ServiceSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/service",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.service.tabTitle"
    })
  });
};
export const ContentSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/content",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.content.tabTitle"
    })
  });
};
export const DataSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/data",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.data.tabTitle"
    })
  });
};
export const CommerceSideNavItem = () => {
  const isSeatsUser = useIsSeatsUser();
  if (!isSeatsUser) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/commerce",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.commerce.tabTitle"
    })
  });
};
export const HubspotCreditsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/hubspot-credits",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.hubspotCredits.tabTitle"
    })
  });
};
export const AddOnsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/add-ons",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.add-ons.tabTitle"
    })
  });
};